import React, { useEffect, useState } from 'react';
import '../../shop/styles/purchaseModal.css';
import './DatumSpinModal.css';
import datumSpinBg from '../../../assets/datum_sping_bg.png';
import { useTranslation } from 'react-i18next';
import { msg, tr } from '../../../i18n/msg';
import { MODULE_TYPE_LABELS } from '../../../shared/utils/gameLabels';

const TICKET = msg('reward.ticket', 'Ticket');
const TICKETS = msg('reward.tickets', 'Tickets');

// Prize pool preview — static showcase, mirrors the rewards available on the wheel.
// kind drives the cell accent: gram (blue) / ticket (pink) / module (purple)
const PRIZE_POOL = [
  { kind: 'gram',   icon: '/gram.png',             value: '0,1', label: 'GRAM' },
  { kind: 'gram',   icon: '/gram.png',             value: '0,5', label: 'GRAM' },
  { kind: 'gram',   icon: '/gram.png',             value: '1',   label: 'GRAM' },
  { kind: 'gram',   icon: '/gram.png',             value: '2,5', label: 'GRAM' },
  { kind: 'ticket', icon: '/ticket_icon.png',      value: '1',   label: TICKET },
  { kind: 'ticket', icon: '/ticket_5.png',         value: '3',   label: TICKETS },
  { kind: 'ticket', icon: '/ticket_5.png',         value: '5',   label: TICKETS },
  { kind: 'ticket', icon: '/ticket_5.png',         value: '10',  label: TICKETS },
  { kind: 'module', icon: '/slider/leg.png',       label: MODULE_TYPE_LABELS.LEG },
  { kind: 'module', icon: '/slider/hand_left.png', label: MODULE_TYPE_LABELS.HAND },
  { kind: 'module', icon: '/slider/torso.png',     label: MODULE_TYPE_LABELS.BODY },
  { kind: 'module', icon: '/slider/head.png',      label: MODULE_TYPE_LABELS.HEAD },
];

export default function DatumSpinModal({ onClose }) {
  const { t } = useTranslation();
  const [visible, setVisible] = useState(false);

  useEffect(() => { setVisible(true); }, []);

  const handleClose = () => {
    setVisible(false);
    setTimeout(onClose, 300);
  };

  return (
    <div className="purchase-modal-overlay" onClick={handleClose}>
      <div
        className={`purchase-modal-sheet ds-sheet ${visible ? 'visible' : ''}`}
        onClick={e => e.stopPropagation()}
      >
        {/* Header — same shell as the other bottom sheets (AutoCollect, DatumPass) */}
        <div className="purchase-modal-header ds-header">
          <h2 className="purchase-modal-title ds-title">Datum Spin</h2>
          <img
            className="purchase-modal-close"
            src="/close.png"
            alt="close"
            onClick={handleClose}
          />
        </div>

        <div className="ds-divider" />

        <div className="ds-body">
          {/* Hero image */}
          <div className="ds-hero">
            <img className="ds-hero-img" src={datumSpinBg} alt="Datum Spin" />
            <div className="ds-hero-caption">
              <span className="ds-hero-caption-title">{t('datum_spin.last_ticket', 'Last ticket left!')}</span>
              <span className="ds-hero-caption-sub">{t('datum_spin.keep_rolling', 'Keep rolling Datum Spin — big prizes are still in the pool')}</span>
            </div>
          </div>

          {/* Section title */}
          <div className="ds-section-title">
            <span>{t('datum_spin.pool_title', 'Rewards in the prize pool')}</span>
          </div>

          {/* Prize grid */}
          <div className="ds-grid">
            {PRIZE_POOL.map((prize, i) => (
              <div
                key={i}
                className={`ds-cell ds-cell--${prize.kind}`}
                style={{ animationDelay: `${120 + i * 35}ms` }}
              >
                <img className="ds-cell-icon" src={prize.icon} alt={`${prize.value ?? ''} ${tr(t, prize.label)}`.trim()} />
                {prize.value && <span className="ds-cell-value">{prize.value}</span>}
                <span className="ds-cell-label">{tr(t, prize.label)}</span>
              </div>
            ))}
          </div>
        </div>

        {/* CTA */}
        <div className="ds-footer">
          <button className="app-btn app-btn--green" onClick={handleClose}>
            {t('datum_spin.continue', 'Continue rolling')}
          </button>
        </div>
      </div>
    </div>
  );
}
